<section class="pda-carousel">
    <ngb-carousel #carousel [interval]="5000" [pauseOnHover]="false" [pauseOnFocus]="true" (slide)="onSlide($event)">
        <ng-template ngbSlide *ngFor="let slide of slides; index as i">
            <div class="pda-carousel-slide-wrapper">
                <div class="pda-carousel-slide-img" [ngStyle]="{
                    'background-image': 'url(' + slide.url + ')'
                }">
                    <div class="pda-carousel__slogan {{slide.position}}" *ngIf="slide.showSlogan">
                        <div class="pda-carousel__slogan1">
                            <h1>ATRÉVETE</h1>
                        </div>
                        <div class="pda-carousel__slogan2">
                            <h2>VUELA</h2>
                        </div>
                    </div>
                    <!--<div class="pda-carousel-slide-caption">
                        <h1>ALLEGRA</h1>
                        <h2>POLE DANCE</h2>
                    </div>
                -->
                </div>
            </div>
        </ng-template>
    </ngb-carousel>
</section>